import StaticStickitView from './static_stickit_view';

export default StaticStickitView.extend({
  bindings: {
    '.js-daytime-availability': {
      observe: ['morning_availability', 'midday_availability', 'evening_availability'],
      onGet(values, options) {
        let value = 'midday_availability';
        $.each(options.observe, (index, option) => {
          if (values[index]) {
            value = option;
          }
        });
        return value;
      },
      onSet(value, options) {
        return options.observe.map(v => v === value);
      },
    },
  },
  fields: ['morning_availability', 'midday_availability', 'evening_availability'],
  initialize(options) {
    StaticStickitView.prototype.initialize.apply(this, options);
    this.availabilityCache = new Backbone.Model({
      'dog-walking': 'midday_availability',
      'drop-in': false,
    });

    this.listenTo(this.model, 'change:service_type', _.bind(this.setAvailabilityToLastValue, this));
    this.listenTo(this.model, 'change:service_type', _.bind(this.updateVisibility, this));

    _.each(
      this.fields,
      function(field, index) {
        this.listenTo(this.model, `change:${field}`, function(model, value) {
          if (value) {
            this.storeAvailabilityForServiceType(field);
          }
        });
      },
      this
    );
    this.updateVisibility(this.model, this.model.get('service_type'));
  },
  render() {
    StaticStickitView.prototype.render.apply(this);
    this.$el.removeClass('hidden');
  },
  updateVisibility(model, serviceType) {
    const shouldBeVisible = this.calculateVisibility(serviceType);
    if (shouldBeVisible) {
      this.$el.removeClass('hidden');
    } else {
      this.$el.addClass('hidden');
    }
  },
  calculateVisibility(serviceType) {
    // Currently we only show this filter for dog-walking searches
    return serviceType === 'dog-walking';
  },
  setAvailabilityToLastValue(model, serviceType) {
    let attributes = {},
      cached_value = this.availabilityCache.get(serviceType);

    _.each(this.fields, field => {
      attributes[field] = cached_value === field;
    });
    this.model.set(attributes);
  },
  storeAvailabilityForServiceType(availability) {
    this.availabilityCache.set(this.model.get('service_type'), availability);
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/daytime_availability_selection_view.js